import React from 'react';
import { Pane } from '@leverege/ui-elements';
import AttributeDetailRenderer from "./AttributeDetailRenderer.js";
import Attributes from '../../attribute/Attributes.js';
import { jsx as _jsx } from "react/jsx-runtime";
export default class ImageDetailRenderer extends AttributeDetailRenderer {
  /**
   * Returns a component to be rendered as the value
   */
  getValueComponent(value, valueStyle, object) {
    const attr = Attributes.getAttribute(this.name, object.type);
    const {
      name
    } = attr;
    const vName = name?.split(/[./ ]/)?.map((value, index) => index ? `${value[0]?.toUpperCase()}${value.slice(1)}` : value)?.join('');
    const variant = `${vName}DetailValue|imageDetailValue`;
    return /*#__PURE__*/_jsx("div", {
      children: Array.isArray(value) && value.map((entry, index, array) => {
        if (index % 2 === 1) {
          return null;
        }
        return /*#__PURE__*/_jsx("div", {
          style: {
            display: 'flex',
            alignItems: 'center',
            flexWrap: 'nowrap'
          },
          children: /*#__PURE__*/_jsx(Pane, {
            variant: variant,
            style: {
              ...valueStyle,
              backgroundImage: `url(${entry})`
            }
          })
        }, entry);
      })
    });
  }
}